import { parseTourDates } from "@/lib/fields";

// Shared period options used by the reusable <PeriodFilter> across pages.
export const PERIODS = [
  { k: "year", label: "This Year" },
  { k: "last", label: "Last Year" },
  { k: "last30", label: "Last 30 Days" },
  { k: "all", label: "All Time" },
  { k: "custom", label: "Custom" },
];

export const periodLabelFor = (k) => PERIODS.find((p) => p.k === k)?.label || "This Year";

// Date bounds [start, end] (Date objects or null = open-ended). null return = all time.
export const periodBounds = (period, from, to) => {
  const t = new Date(); t.setHours(0, 0, 0, 0);
  if (period === "last30") { const f = new Date(t); f.setDate(t.getDate() - 29); return [f, null]; }
  if (period === "year") return [new Date(t.getFullYear(), 0, 1), new Date(t.getFullYear(), 11, 31, 23, 59, 59, 999)];
  if (period === "last") return [new Date(t.getFullYear() - 1, 0, 1), new Date(t.getFullYear() - 1, 11, 31, 23, 59, 59, 999)];
  if (period === "custom") {
    const f = from ? new Date(from + "T00:00:00") : null;
    const e = to ? new Date(to + "T00:00:00") : null;
    if (e) e.setHours(23, 59, 59, 999);
    return [f, e];
  }
  return null; // all time
};

export const tourInBounds = (tour, b) => {
  if (!b) return true;
  const [f, e] = b;
  const ds = parseTourDates(tour.tour_date);
  return ds.length ? ds.some((d) => (!f || d >= f) && (!e || d <= e)) : false;
};

// ISO (YYYY-MM-DD) range for string-date collections (e.g. call-outs' date_iso).
export const periodIsoRange = (period, from, to) => {
  const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  const now = new Date();
  const y = now.getFullYear();
  if (period === "year") return [`${y}-01-01`, `${y}-12-31`];
  if (period === "last") return [`${y - 1}-01-01`, `${y - 1}-12-31`];
  if (period === "last30") { const s = new Date(now); s.setDate(now.getDate() - 29); return [iso(s), iso(now)]; }
  if (period === "custom") return [from || "0000-01-01", to || "9999-12-31"];
  return null; // all time
};
